// Registre des icones : nom historique (css.gg / Font Awesome) -> composant lucide-react.
// Les imports nommes statiques ci-dessous sont indispensables au tree-shaking Webpack :
// ne jamais y substituer un import() dynamique ni un acces par cle construite sur le namespace.
// Catalogue complet : https://lucide.dev/icons
import {
    ArrowDown,
    ArrowRight,
    ArrowUp,
    Asterisk,
    AudioWaveform,
    Award,
    Ban,
    Banknote,
    Bell,
    Blocks,
    Book,
    Box,
    Boxes,
    Calculator,
    Calendar,
    ChartLine,
    ChartPie,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Circle,
    CircleAlert,
    CircleArrowRight,
    CircleCheck,
    CirclePause,
    CirclePlay,
    CircleQuestionMark,
    CircleUser,
    CircleX,
    Clipboard,
    Clock,
    Cog,
    Copy,
    CreditCard,
    Download,
    EllipsisVertical,
    Euro,
    Expand,
    ExternalLink,
    Eye,
    EyeOff,
    File,
    FileDown,
    FileImage,
    FileText,
    FileUp,
    FolderOpen,
    Forward,
    Frown,
    Gauge,
    Gift,
    Heart,
    History,
    House,
    Image,
    Info,
    Languages,
    Layers,
    LayoutGrid,
    Leaf,
    Lightbulb,
    List,
    LoaderCircle,
    Lock,
    LockOpen,
    LogIn,
    LogOut,
    Mail,
    MapPin,
    Menu,
    Merge,
    MessageSquare,
    MessagesSquare,
    Minus,
    MousePointerClick,
    NotepadText,
    Paperclip,
    Pen,
    Percent,
    Phone,
    Pin,
    Plane,
    Plus,
    Printer,
    QrCode,
    Recycle,
    Redo2,
    RefreshCw,
    Scan,
    Search,
    Send,
    Settings,
    ShieldUser,
    ShoppingCart,
    SlidersHorizontal,
    Smile,
    Tag,
    Tags,
    Terminal,
    ThumbsUp,
    Trash2,
    TriangleAlert,
    Truck,
    Undo2,
    User,
    UserMinus,
    UserPlus,
    UserX,
    Users,
    X,
    Zap,
} from 'lucide-react';

export const ICON_MAP = {
    'add': Plus,
    'airplane': Plane,
    'arrow-circle-right': CircleArrowRight,
    'arrow-long-down': ArrowDown,
    'arrow-long-up': ArrowUp,
    'arrow-right': ArrowRight,
    'arrows-expand-up-right': Expand,
    'asterisk': Asterisk,
    'attachment': Paperclip,
    'awards': Award,

    'ban': Ban,
    'bars': Menu,
    'bell': Bell,
    'bolt': Zap,
    'book': Book,
    'box': Box,

    'calculator': Calculator,
    'calendar-dates': Calendar,
    'cap': Truck,
    'caret-down': ChevronDown,
    'caret-up': ChevronUp,
    'cart-plus': ShoppingCart,
    'chart-line': ChartLine,
    'chart-pie': ChartPie,
    'check': Check,
    'check-o': CircleCheck,
    'chevron-down': ChevronDown,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'chevron-up': ChevronUp,
    'clipboard': Clipboard,
    'clone': Copy,
    'close': X,
    'close-o': CircleX,
    'comment': MessageSquare,
    'comments': MessagesSquare,
    'components': Blocks,
    'credit-card': CreditCard,
    'cube': Box,
    'cubes': Boxes,
    'custom': SlidersHorizontal,

    'danger': TriangleAlert,

    'enter': LogIn,
    'euro': Euro,
    'exclamation': CircleAlert,
    'exclamation-triangle': TriangleAlert,
    'external-link-alt': ExternalLink,
    'eye': Eye,
    'eye-slash': EyeOff,
	'eye-off': EyeOff,

    'file': File,
    'file-document': FileText,
    'file-download': FileDown,
    'file-image': FileImage,
    'file-upload': FileUp,
    'folder-open': FolderOpen,
    'forward': Forward,

    'gear': Settings,
    'gears': Cog,
    'gift': Gift,

    'hand-pointer': MousePointerClick,
    'heart': Heart,
    'history': History,
    'home': House,

    'image': Image,
    'info': Info,
    'info-circle': Info,

    'language': Languages,
    'leaf': Leaf,
    'lightbulb-o': Lightbulb,
    'list': List,
    'lock': Lock,
    'lock-unlock': LockOpen,
    'lock-unlock-alt': LockOpen,
    'log-in': LogIn,
    'log-off': LogOut,

    'mail': Mail,
    'marker': MapPin,
    'menu': Menu,
    'merge-vertical': Merge,
    'money-bill-alt': Banknote,
    'more-vertical': EllipsisVertical,

    'notes': NotepadText,

    'paper-plane': Send,
    'paper-plane-o': Send,
    'pause-circle': CirclePause,
    'pen': Pen,
    'percent': Percent,
    'phone': Phone,
    'pin': MapPin,
    'pin-alt': Pin,
    'play-button-o': CirclePlay,
    'play-pause-o': CirclePause,
    'printer': Printer,

    'qr': QrCode,
    'question-circle': CircleQuestionMark,

    'recycle': Recycle,
    'redo': Redo2,
    'remove': Minus,

    'scan': Scan,
    'search': Search,
    'shape-circle': Circle,
    'shopping-cart': ShoppingCart,
    'frown': Frown,
    'smile': Smile,
    'smile-sad': Frown,
    'software-download': Download,
    'spinner': LoaderCircle,
    'stack': Layers,
    'sync': RefreshCw,

    'tachometer-alt': Gauge,
    'tag': Tag,
    'tags': Tags,
    'terminal': Terminal,
    'thumbs-up': ThumbsUp,
    'time': Clock,
    'times': X,
    'trash': Trash2,
    'truck': Truck,

    'ui-kit': LayoutGrid,
    'undo': Undo2,
    'user': User,
    'user-add': UserPlus,
    'user-list': Users,
    'user-o': CircleUser,
    'user-remove': UserMinus,
    'user-shield': ShieldUser,
    'user-slash': UserX,
    'users': Users,

    'wave-square': AudioWaveform,
};

export default ICON_MAP;
